import {
  FIBER_SITE_PLANNING_UPLOAD_EXCEL,
  FIBER_SITE_PLANNING_UPLOAD_STATUS,
} from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

const POLL_INTERVAL_MS = 500;

/**
 * Upload Excel for FTTS site list: starts job, polls for progress, returns final result.
 * @param {FormData} formData - FormData with 'file' key
 * @param {Object} onProgress - callback({ progress, stage, message })
 * @returns {Promise<{ result: Object }>}
 */
export const uploadFiberSitePlanningExcel = async (formData, onProgress) => {
  const response = await apiClient.post(FIBER_SITE_PLANNING_UPLOAD_EXCEL, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  const data = response?.data?.response ?? response?.data;
  const jobId = data?.jobId;
  if (!jobId) {
    throw new Error('Server did not return a job ID');
  }

  return new Promise((resolve, reject) => {
    const poll = async () => {
      try {
        const statusRes = await apiClient.get(FIBER_SITE_PLANNING_UPLOAD_STATUS(jobId));
        const statusData = statusRes?.data?.response ?? statusRes?.data;
        const { status, progress, stage, message, result, error } = statusData ?? {};

        if (typeof progress === 'number' && onProgress) {
          onProgress({ progress, stage, message });
        }

        if (status === 'completed') {
          resolve({ result });
          return;
        }
        if (status === 'failed') {
          reject(new Error(error || 'Upload failed'));
          return;
        }

        setTimeout(poll, POLL_INTERVAL_MS);
      } catch (err) {
        handleApiError(err);
        reject(err);
      }
    };

    poll();
  });
};
